module.exports = __webpack_public_path__ + "static/media/img_socialmedia-04Whatsapp.9c0b6b78.png";